<template>
  <div id="app">
    <img src="@/assets/pink.svg" alt="pink circle" class="dot">
    <img src="@/assets/bar.svg" alt="green bar" class="bar">
    <img src="@/assets/dot-blue.svg" alt="blue corner dot" class="corner">
    <div class="content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <Footer class="bottom" />
  </div>
</template>

<script>
import Footer from "./components/footer"

export default {
  name: "App",
  components: {
   Footer
  },
  created() {
    //https://experiments.braingineers.com/.netlify/functions/getAverages
    ///.netlify/functions/getAverages
    fetch(".netlify/functions/getAverages")
      .then(response => {
        return response.json();
      })
      .then(myJson => {
        this.$store.commit(
          "setGroupA",
          myJson.data.valueRanges[0].values[0][0]
        );
        this.$store.commit(
          "setGroupB",
          myJson.data.valueRanges[1].values[0][0]
        );
        this.$store.commit("setTotal", myJson.data.valueRanges[2].values[0][0]);
      });
  }
};
</script>

<style>
@import "./app.css";

* { 
  margin: 0;
  padding: 0;
}

#app {
  margin-top: 100px;
  margin-bottom: 100px;
}

.dot {
  position: absolute;
  bottom: 50px;
  right: 150px;
  height: 25px;
  z-index: -1;
}

.bar {
  position: absolute;
  left: 0;
  bottom: 5%;
  height: 50%;
  z-index: -1;
}

.corner {
  position: absolute;
  top: 0;
  right: 0;
  height: 15%;
  z-index: -1;
}

.bottom {
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  padding-right: 20px;
}

</style>
